/**
 * 数据分析-楼盘信息统计-详情列表
 * luxinwen
 * 2023-04-26
 */
<template>
  <div class="page">
    <div class="page-main">
      <div class="top-form" v-grant="'OSP_ANALYSIS_PROJECT_QUERY'">
        <Form :model="formData" inline>
          <FormItem>
            <DatePicker class="width-m" v-model="formData.recommendTime" type="datetimerange" placeholder="请选择时间" />
          </FormItem>
          <FormItem>
            <Button type="primary" @click="queryData">查询</Button>
          </FormItem>
        </Form>
      </div>
      <div class="page-main-content" v-grant="'OSP_ANALYSIS_PROJECT_EXPORT'">
        <Button type="primary" @click="exportData">导出</Button>
        <Button @click="showRecord">查看导出记录</Button>
      </div>
      <div class="page-main-content">
        <sp-table :columns="tableColumns" :data="tableData" :loading="tableLoading" :total="pager.total" :page="pager.pageNum" :page-size="pager.pageSize" @change="changePage">
          <template slot-scope="params" slot="shareNum">
            <span class="link" @click="showDetail(params.row, 'share')">{{ params.row.shareCount }}</span>
          </template>
          <template slot-scope="params" slot="visitNum">
            <span class="link" @click="showDetail(params.row, 'visit')">{{ params.row.byShareCount }}</span>
          </template>
        </sp-table>
      </div>
    </div>

    <Modal v-model="recordDisplay" width="80%" title="导出记录" footer-hide :mask-closable="false">
      <sp-table :columns="recordColumns" :data="recordDataList" :loading="recordLoading" :total="recordPager.total" :page="recordPager.pageNum" :page-size="recordPager.pageSize" @change="changeRecordPage">
      </sp-table>
    </Modal>
  </div>
</template>

<script>
  export default {
    components: {
    },
    data() {
      return {
        formData: {
          recommendTime: []
        },
        tableColumns: [
          {
            title: '经纪人',
            key: 'memberName'
          },
          {
            title: '分享总次数',
            key: 'shareNum'
          },
          {
            title: '被查看总次数',
            key: 'shareViewNum'
          },
          {
            title: '扫码总人数',
            key: 'scanNum'
          },
          {
            title: '扫码注册',
            key: 'regNum'
          },
          {
            title: '扫码成为经纪人',
            key: 'certifNum'
          }
        ],
        tableData: [],
        tableLoading: false, // 表格查询状态
        pager: {
          total: 0,     // 总条数
          pageNum: 1,   // 当前页码
          pageSize: 10  // 每页条数
        },
        drawerDisplay: false, // 是否显示编辑抽屉
        drawerData: {},       // 编辑抽屉数据
        drawerFlag: 'share',  // 编辑抽屉状态
        dataId: '',
        recordDisplay: false,
        recordColumns: [
          {
            type: 'index',
            title: '序号',
            width: 100,
            align: 'center'
          },
          {
            title: '文件名',
            key: 'fileName'
          },
          {
            title: '操作人',
            key: 'operator'
          },
          {
            title: '导出时间',
            key: 'createdTime'
          },
          {
            title: '操作',
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('a', {
                  attrs: {
                    href: params.row.downloadUrl,
                    target: '_blank'
                  }
                }, '请下载')
              ]);
            }
          }
        ],
        recordDataList: [],
        recordLoading: false,
        recordPager: {
          total: 0,
          pageNum: 1,
          pageSize: 10
        }
      };
    },
    created() {
      this.getData();
    },
    methods: {
      /**
       * 获取数据
       */
      getData() {
        let data = Object.assign({}, {
          pageNum: this.pager.pageNum,
          pageSize: this.pager.pageSize
        });
        if (this.formData.recommendTime.length > 1) {
          data.queryStartDate = this.formatDate(this.formData.recommendTime[0]);
          data.queryEndDate = this.formatDate(this.formData.recommendTime[1]);
        }
        this.$axios({
          url: this.$api.analysis.queryBroker,
          data,
          beforeSend: () => {
            this.tableLoading = true;
          },
          complete: () => {
            this.tableLoading = false;
          }
        }).then(data => {
          this.tableData = data.list || [];
          this.pager.total = data.total || 0;
        });
      },
      /**
       * 查询数据
       */
      queryData() {
        this.pager.pageNum = 1;
        this.getData();
      },
      /**
       * 查看导出记录
       */
      showRecord() {
        this.recordDisplay = true;
        this.getRecordData();
      },
      /**
       * 获取导出记录数据
       */
      getRecordData() {
        let params = {
          operationType: 'MEMBER_COUNT',
          pageNum: this.recordPager.pageNum,
          pageSize: this.recordPager.pageSize
        };
        this.$axios({
          url: this.$api.analysis.exportRecordList,
          data: params,
          beforeSend: () => {
            this.recordLoading = true;
          },
          complete: () => {
            this.recordLoading = false;
          }
        }).then(data => {
          this.recordDataList = data.list || [];
          this.recordPager.total = data.total || 0;
        });
      },
      /**
       * 导出
       */
      exportData() {
        let data = Object.assign({}, {
        });
        if (this.formData.recommendTime.length > 1) {
          data.queryStartDate = this.formatDate(this.formData.recommendTime[0]);
          data.queryEndDate = this.formatDate(this.formData.recommendTime[1]);
        }
        this.$axios({
          url: this.$api.analysis.exportBroker,
          data,
          loading: true
        }).then(data => {
          this.notice({
            type: 'success',
            desc: '操作成功，请稍后查看导出记录'
          });
        });
      },
      /**
       * 查看
       */
      showDetail(row, type) {
        this.drawerFlag = type;
        this.drawerData = row;
        this.drawerDisplay = true;
      },
      /**
       * 切换页码或每条页数
       */
      changeRecordPage(pager) {
        this.recordPager.pageNum = pager.page;
        this.recordPager.pageSize = pager.pageSize;
        this.getRecordData();
      },
      /**
       * 切换页码或每条页数
       */
      changePage(pager) {
        this.pager.pageNum = pager.page;
        this.pager.pageSize = pager.pageSize;
        this.getData();
      }
    }
  };
</script>